export default __webpack_public_path__ + "static/media/feather-edit.04bae3da.svg";